/**
 * This file is auto-generated from your GraphQL schema.
 * Do not edit this file directly.
 */

export enum AiPromptType {
  GenerateProfileSummary = 'GENERATE_PROFILE_SUMMARY',
  SuggestJobDescription = 'SUGGEST_JOB_DESCRIPTION',
  SuggestJobTitle = 'SUGGEST_JOB_TITLE',
}

export enum AppContext {
  ClientApp = 'CLIENT_APP',
  Portal = 'PORTAL',
  WorkerApp = 'WORKER_APP',
}

export enum AssetFileType {
  Csv = 'CSV',
  Doc = 'DOC',
  Docx = 'DOCX',
  Heic = 'HEIC',
  Heif = 'HEIF',
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG',
  Pptx = 'PPTX',
  Webp = 'WEBP',
  Xls = 'XLS',
  Xlsx = 'XLSX',
}

export enum AssetStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Replaced = 'REPLACED',
}

export enum BreakType {
  MealBreak = 'MEAL_BREAK',
  Other = 'OTHER',
  Paid = 'PAID',
  Unpaid = 'UNPAID',
}

export enum BudgetLimitCategory {
  ActiveClientsPerMonth = 'ACTIVE_CLIENTS_PER_MONTH',
  ActiveWorkersPerMonth = 'ACTIVE_WORKERS_PER_MONTH',
  AiRequestsPerMonth = 'AI_REQUESTS_PER_MONTH',
  JobPostingsPerMonth = 'JOB_POSTINGS_PER_MONTH',
  NotificationsPerMonth = 'NOTIFICATIONS_PER_MONTH',
}

export enum ClassificationGroupStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum ClassificationLevelStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum ClassificationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum ClientStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export enum DaySequenceStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  PayProcessed = 'PAY_PROCESSED',
  Pending = 'PENDING',
  ReadyForPay = 'READY_FOR_PAY',
  Unfilled = 'UNFILLED',
}

export enum DraftJobState {
  Created = 'CREATED',
  Discarded = 'DISCARDED',
  Error = 'ERROR',
  MissingInformation = 'MISSING_INFORMATION',
  PendingApprovalByClient = 'PENDING_APPROVAL_BY_CLIENT',
  PendingCreation = 'PENDING_CREATION',
  Posted = 'POSTED',
  ReadyToPost = 'READY_TO_POST',
  Rejected = 'REJECTED',
  ShouldPostNextChance = 'SHOULD_POST_NEXT_CHANCE',
}

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  InviteSent = 'INVITE_SENT',
  PendingSend = 'PENDING_SEND',
}

export enum InvoiceStatus {
  Any = 'ANY',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  NoInvoiceRequiredYet = 'NO_INVOICE_REQUIRED_YET',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING',
}

export enum ItemStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Any = 'ANY',
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  JobFinished = 'JOB_FINISHED',
  Unfilled = 'UNFILLED',
}

export enum JobAcceptType {
  Accept = 'ACCEPT',
  Apply = 'APPLY',
}

export enum JobApplicationStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN',
}

export enum JobFrequency {
  Daily = 'DAILY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Other = 'OTHER',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export enum JobStartType {
  Asap = 'ASAP',
  Flexible = 'FLEXIBLE',
  StartAfter = 'START_AFTER',
  StartOn = 'START_ON',
}

export enum JobStatus {
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Filled = 'FILLED',
  Unfilled = 'UNFILLED',
}

export enum ObjectType {
  Asset = 'ASSET',
  AssetTemplate = 'ASSET_TEMPLATE',
  AuditLog = 'AUDIT_LOG',
  BudgetRecord = 'BUDGET_RECORD',
  Classification = 'CLASSIFICATION',
  ClassificationAssetMapping = 'CLASSIFICATION_ASSET_MAPPING',
  ClassificationGroup = 'CLASSIFICATION_GROUP',
  ClassificationLevel = 'CLASSIFICATION_LEVEL',
  Client = 'CLIENT',
  Contract = 'CONTRACT',
  ContractTemplate = 'CONTRACT_TEMPLATE',
  CoreLoopConfiguration = 'CORE_LOOP_CONFIGURATION',
  CustomAttribute = 'CUSTOM_ATTRIBUTE',
  CustomAttributeConfiguration = 'CUSTOM_ATTRIBUTE_CONFIGURATION',
  DaySequence = 'DAY_SEQUENCE',
  Device = 'DEVICE',
  FavouriteUser = 'FAVOURITE_USER',
  FcmToken = 'FCM_TOKEN',
  Feature = 'FEATURE',
  InboxItem = 'INBOX_ITEM',
  Initializer = 'INITIALIZER',
  Invite = 'INVITE',
  InvoicesExport = 'INVOICES_EXPORT',
  Job = 'JOB',
  JobApplication = 'JOB_APPLICATION',
  Onboarding = 'ONBOARDING',
  OnboardingTemplate = 'ONBOARDING_TEMPLATE',
  Plan = 'PLAN',
  PlanSubscription = 'PLAN_SUBSCRIPTION',
  Policy = 'POLICY',
  PolicyTemplate = 'POLICY_TEMPLATE',
  Template = 'TEMPLATE',
  Tenant = 'TENANT',
  TenantPayConfiguration = 'TENANT_PAY_CONFIGURATION',
  Theme = 'THEME',
  Timesheet = 'TIMESHEET',
  TimesheetsExport = 'TIMESHEETS_EXPORT',
  User = 'USER',
  Worker = 'WORKER',
}

export enum OnboardingPageType {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC',
}

export enum OnboardingQuestionType {
  Address = 'ADDRESS',
  BankAccount = 'BANK_ACCOUNT',
  Boolean = 'BOOLEAN',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  DisplayOnly = 'DISPLAY_ONLY',
  Dropdown = 'DROPDOWN',
  Email = 'EMAIL',
  EnableLocation = 'ENABLE_LOCATION',
  EnableNotification = 'ENABLE_NOTIFICATION',
  FileUpload = 'FILE_UPLOAD',
  MultiLineTextInput = 'MULTI_LINE_TEXT_INPUT',
  MultiSelect = 'MULTI_SELECT',
  NoDisplay = 'NO_DISPLAY',
  Phone = 'PHONE',
  PhotoUpload = 'PHOTO_UPLOAD',
  Policy = 'POLICY',
  Radio = 'RADIO',
  Signature = 'SIGNATURE',
  SingleSelect = 'SINGLE_SELECT',
  TextInput = 'TEXT_INPUT',
  Time = 'TIME',
  ValueSlider = 'VALUE_SLIDER',
}

export enum OnboardingRole {
  Client = 'CLIENT',
  Worker = 'WORKER',
}

export enum OnboardingStatus {
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
}

export enum PartialUpdateErrorType {
  AllOrNothingFailed = 'ALL_OR_NOTHING_FAILED',
  InvalidAttributeName = 'INVALID_ATTRIBUTE_NAME',
  InvalidObject = 'INVALID_OBJECT',
  InvalidObjectId = 'INVALID_OBJECT_ID',
  InvalidObjectType = 'INVALID_OBJECT_TYPE',
  InvalidValue = 'INVALID_VALUE',
  InvalidValueType = 'INVALID_VALUE_TYPE',
  PermissionDenied = 'PERMISSION_DENIED',
  UnknownError = 'UNKNOWN_ERROR',
}

export enum PayRunStatus {
  Complete = 'COMPLETE',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
}

export enum PolicyStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Superseded = 'SUPERSEDED',
}

export enum PolicyType {
  Other = 'OTHER',
  PrivacyPolicy = 'PRIVACY_POLICY',
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
}

/** Values align with GraphQL `contractType` (same string style as `PolicyType`). */
export enum ContractType {
  Primary = 'PRIMARY',
  HireContract = 'HIRE_CONTRACT',
  Declaration = 'DECLARATION',
  Other = 'OTHER',
}

export enum QueryTypes {
  Owner = 'OWNER',
}

export enum S3UploadType {
  Asset = 'ASSET',
  ClientLogo = 'CLIENT_LOGO',
  Contract = 'CONTRACT',
  Invoice = 'INVOICE',
  JobApplication = 'JOB_APPLICATION',
  JobPostingPhoto = 'JOB_POSTING_PHOTO',
  Misc = 'MISC',
  Other = 'OTHER',
  Policy = 'POLICY',
  ProfilePicture = 'PROFILE_PICTURE',
  TenantLogo = 'TENANT_LOGO',
  Timesheet = 'TIMESHEET',
}

export enum SupportedLanguage {
  Arabic = 'ARABIC',
  Cantonese = 'CANTONESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Lao = 'LAO',
  Mandarin = 'MANDARIN',
  Spanish = 'SPANISH',
  Tagalog = 'TAGALOG',
  Thai = 'THAI',
  Vietnamese = 'VIETNAMESE',
}

export enum TenantApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED',
}

export enum ThemeType {
  ClientApp = 'CLIENT_APP',
  ClientWeb = 'CLIENT_WEB',
  HqApp = 'HQ_APP',
  HqWeb = 'HQ_WEB',
  TenantApp = 'TENANT_APP',
  TenantWeb = 'TENANT_WEB',
  WorkerApp = 'WORKER_APP',
  WorkerWeb = 'WORKER_WEB',
}

export enum ThrottleLimitCategory {
  DeletesPerMinute = 'DELETES_PER_MINUTE',
  NotificationsPerMinute = 'NOTIFICATIONS_PER_MINUTE',
  ReadsPerMinute = 'READS_PER_MINUTE',
  UpdatesPerMinute = 'UPDATES_PER_MINUTE',
  WritesPerMinute = 'WRITES_PER_MINUTE',
}

export enum TimeUnit {
  Days = 'DAYS',
  Fortnight = 'FORTNIGHT',
  Hours = 'HOURS',
  Milliseconds = 'MILLISECONDS',
  Minutes = 'MINUTES',
  Seconds = 'SECONDS',
  Weeks = 'WEEKS',
  Years = 'YEARS',
}

export enum TimesheetStatus {
  ApprovedByClient = 'APPROVED_BY_CLIENT',
  Cancelled = 'CANCELLED',
  ClockedIn = 'CLOCKED_IN',
  ClockedOut = 'CLOCKED_OUT',
  Disputed = 'DISPUTED',
  Invoiced = 'INVOICED',
  Paid = 'PAID',
  PendingApprovalByClient = 'PENDING_APPROVAL_BY_CLIENT',
  PendingStart = 'PENDING_START',
  ReadyForExport = 'READY_FOR_EXPORT',
  Rejected = 'REJECTED',
  RequiresEarlyStartApproval = 'REQUIRES_EARLY_START_APPROVAL',
  RequiresLateFinishApproval = 'REQUIRES_LATE_FINISH_APPROVAL',
  RequiresLocationApproval = 'REQUIRES_LOCATION_APPROVAL',
  RequiresManualApproval = 'REQUIRES_MANUAL_APPROVAL',
  RequiresOvertimeApproval = 'REQUIRES_OVERTIME_APPROVAL',
  RequiresUndertimeApproval = 'REQUIRES_UNDERTIME_APPROVAL',
  Reversed = 'REVERSED',
  Unknown = 'UNKNOWN',
}

export enum UploadType {
  Asset = 'ASSET',
  ClientLogo = 'CLIENT_LOGO',
  ProfilePicture = 'PROFILE_PICTURE',
  TenantLogo = 'TENANT_LOGO',
}

export enum UserRole {
  ClientAdmin = 'CLIENT_ADMIN',
  ClientUser = 'CLIENT_USER',
  HqAdmin = 'HQ_ADMIN',
  TenantAdmin = 'TENANT_ADMIN',
  TenantUser = 'TENANT_USER',
  Unknown = 'UNKNOWN',
  Worker = 'WORKER',
}

export enum UserStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED',
}

export enum ValueType {
  Array = 'ARRAY',
  Asset = 'ASSET',
  Boolean = 'BOOLEAN',
  Contract = 'CONTRACT',
  Number = 'NUMBER',
  Object = 'OBJECT',
  String = 'STRING',
}

export enum WorkType {
  Contract = 'CONTRACT',
  DayToDay = 'DAY_TO_DAY',
  FlexibleContract = 'FLEXIBLE_CONTRACT',
  Unknown = 'UNKNOWN',
}
